import React, {Component} from 'react';
import PropTypes from 'prop-types';

import "../assets/stylesheets/Infos.scss";

export default class Infos extends Component {

    static propTypes = {
        hasAllInfos : PropTypes.bool,
        size : PropTypes.string,
        isDownloaded : PropTypes.bool,
        hasError : PropTypes.bool,
    }

    renderAll(){
        return (
            <div className="Infos">
                <div className={"infos" + (this.props.isDownloaded ? " active" : "")}>
                    <div className="file-size">{this.props.size || "0"}</div>
                    <div className="status">{this.props.isDownloaded ? "downloaded"
                        : (this.props.hasError ? "error on download" : "pending") }</div>
                </div>
            </div>
        );
    }

    renderWithoutStatus(){
        return (
            <div className="Infos">
                <div className={"infos" + (this.props.isDownloaded ? " active" : "")}>
                    <div className="file-size">{this.props.size || "0"}</div>
                </div>
            </div>
        );
    }

    render(){
        return this.props.hasAllInfos ? this.renderAll() : this.renderWithoutStatus();
    }
}



// WEBPACK FOOTER //
// ./src/components/Infos.js